import React, { Component } from "react";
import { List, ListItem } from "material-ui/List";
import Checkbox from "material-ui/Checkbox";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import styled from "styled-components";
import ReactMarkdown from "react-markdown";
import Paper from "material-ui/Paper";

class SpecText extends Component {
  constructor(props) {
    super(props);

    this.state = { expanded: true };

    this.handleClick = this.handleClick.bind(this);
  }

  handleClick(event) {
    this.setState({ expanded: !this.state.expanded });
  }

  render() {
    let details;
    if (this.state.expanded) {
      var that = this;
      function findEventForId(eventId, events) {
        function findEvent(localType) {
          return localType.id === eventId;
        }
        let found = events.find(findEvent);
        return found;
      }
      function findFlowForId(flowId) {
        function findFlow(flow) {
          return flow.id === flowId;
        }
        let found = that.props.allFlows.find(findFlow);
        console.log(
          "findFlowForId " +
            flowId +
            " in " +
            that.props.allFlows +
            ", e.g. " +
            that.props.allFlows[0].id +
            " found: " +
            found
        );
        return found;
      }
      let detailText;
      function findForIdMatch(m, p1) {
        return (
          "`" +
          findEventForId(parseInt(p1), that.props.ownEventsOutput).name +
          "`->"
        );
      }
      function findForUiEventIdMatch(m, p1) {
        return (
          "->`" + findEventForId(parseInt(p1), that.props.uievents).name + "`"
        );
      }
      function findForFlowEventIdMatch(m, p1) {
        let flowId = parseInt(p1.split(".")[0]);
        let flow = findFlowForId(flowId);
        let eventId = parseInt(p1.split(".")[1]);
        let eventName;
        if (eventId === 0) eventName = "any";
        else {
          let event = findEventForId(eventId, flow.eventsOutput);
          eventName = event.name;
        }
        return "->`" + flow.title + ": " + eventName + "`";
      }
      detailText = this.props.spec;
      detailText = detailText.replace(
        /\*\*\*(\d+\.\d+)\*\*\*/g,
        findForFlowEventIdMatch
      );
      detailText = detailText.replace(/\*\*(\d+)\*\*/g, findForIdMatch);
      detailText = detailText.replace(/\*(\d+)\*/g, findForUiEventIdMatch);
      details = (
        <div style={{ textAlign: "left" }}>
          <ReactMarkdown source={detailText} />
        </div>
      );
    } else {
      details = "";
    }
    return (
      <div style={{ textAlign: "left", padding: 12, fontSize: 12 }}>
        {details}
      </div>
    );
  }
}
export default SpecText;



// WEBPACK FOOTER //
// ./src/components/SpecText.js